import { useNavigate, useLocation } from 'react-router-dom';

const SettingMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: any) => location.pathname === path;
  return (
    <>
      <ul
        className="nav nav-tabs horizontal-tabs-top flex md:flex-row overflow-auto list-none border-b-0 p-2 mb-4 bg-white shadow-card rounded-lg"
        id="tabs-tab"
        role="tablist">
        <li className="nav-item" role="presentation" onClick={() => navigate('/account-settings')}>
          <a
            href="#tabs-profile"
            className={`nav-link tabs-link ${isActive('/account-settings') ? 'active' : ''}`}
            id="tab-profile-tab"
            data-bs-toggle="pill"
            data-bs-target="#tabs-profile"
            role="tab"
            aria-controls="tabs-profile"
            aria-selected={isActive('/account-settings')}>
            <span className="flex items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="h-4 w-4 mr-2"
                xmlns="http://www.w3.org/2000/svg">
                <mask
                  id="mask0_1076_92631"
                  maskUnits="userSpaceOnUse"
                  x="1"
                  y="0"
                  width="14"
                  height="16">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.3999 5.47488L8.39992 0.815773C8.13325 0.616097 7.79992 0.616097 7.59992 0.815773L1.59992 5.47488C1.39992 5.608 1.33325 5.80767 1.33325 6.00735V13.3288C1.33325 14.4603 2.19992 15.3256 3.33325 15.3256H12.6666C13.7999 15.3256 14.6666 14.4603 14.6666 13.3288V6.00735C14.6666 5.80767 14.5999 5.608 14.3999 5.47488ZM9.33325 8.6697V13.9944H6.66658V8.6697H9.33325ZM12.6666 13.9944C13.0666 13.9944 13.3333 13.7282 13.3333 13.3288V6.34014L7.99992 2.21351L2.66659 6.34014V13.3288C2.66659 13.7282 2.93325 13.9944 3.33325 13.9944H5.33325V8.00411C5.33325 7.60476 5.59992 7.33853 5.99992 7.33853H9.99992C10.3999 7.33853 10.6666 7.60476 10.6666 8.00411V13.9944H12.6666Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_1076_92631)">
                  <rect width="16" height="15.9922" fill="currentcolor" />
                </g>
              </svg>
              <span>Account </span>
              <i className="fas fa-chevron-down ml-3"></i>
            </span>
          </a>
        </li>
        <li
          className="nav-item"
          role="presentation"
          onClick={() => navigate('/account-settings/security')}>
          <a
            href="#tabs-security"
            className={`nav-link tabs-link ${
              isActive('/account-settings/security') ? 'active' : ''
            }`}
            data-bs-toggle="pill"
            data-bs-target="#tabs-security"
            role="tab"
            aria-controls="tabs-security"
            aria-selected={isActive('/account-settings/security')}>
            <span className="flex items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="h-4 w-4 mr-2"
                xmlns="http://www.w3.org/2000/svg">
                <mask
                  id="mask0_1076_92624"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="16">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.86675 0.400098L14.2001 3.06547C14.9334 3.39864 15.3334 4.06499 15.3334 4.79796V11.1282C15.3334 11.9278 14.8667 12.5942 14.2001 12.9274L8.86675 15.5927C8.60008 15.726 8.33341 15.7926 8.00008 15.7926C7.73341 15.7926 7.40008 15.726 7.13341 15.5927L1.80008 12.9274C1.06675 12.5942 0.666748 11.8612 0.666748 11.1282V4.79796C0.666748 4.06499 1.06675 3.39864 1.73341 3.06547L7.06675 0.400098C7.66675 0.133561 8.33341 0.133561 8.86675 0.400098ZM8.00008 1.46625C7.93341 1.46625 7.80008 1.46625 7.73341 1.53288L2.80008 3.99835L8.00008 6.59709L13.2001 3.99835L8.26675 1.53288C8.20008 1.46625 8.13341 1.46625 8.00008 1.46625ZM2.33341 11.7946C2.13341 11.6613 2.00008 11.3948 2.00008 11.1949V5.0645L7.33342 7.72988V14.26L2.33341 11.7946ZM8.66675 14.26L13.6001 11.7946C13.8667 11.6613 14.0001 11.4614 14.0001 11.1949V5.0645L8.66675 7.72988V14.26Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_1076_92624)">
                  <rect width="16" height="15.9922" fill="currentcolor" />
                </g>
              </svg>

              <span>Security</span>
              <i className="fas fa-chevron-down ml-3"></i>
            </span>
          </a>
        </li>
        <li
          className="nav-item"
          role="presentation"
          onClick={() => navigate('/account-settings/contacts')}>
          <a
            href="#tabs-security"
            className={`nav-link tabs-link ${
              isActive('/account-settings/contacts') ? 'active' : ''
            }`}
            data-bs-toggle="pill"
            data-bs-target="#tabs-security"
            role="tab"
            aria-controls="tabs-security"
            aria-selected={isActive('/account-settings/contacts')}>
            <span className="flex items-center">
              <i className="fas fa-address-book mr-2"></i>
              <span>Contacts</span>
              <i className="fas fa-chevron-down ml-3"></i>
            </span>
          </a>
        </li>
        <li
          className="nav-item"
          role="presentation"
          onClick={() => navigate('/account-settings/billing')}>
          <a
            href="#tabs-billing"
            className={`nav-link tabs-link ${
              isActive('/account-settings/billing') ? 'active' : ''
            }`}
            id="tabs-billing-tab"
            data-bs-toggle="pill"
            data-bs-target="#tabs-billing"
            role="tab"
            aria-controls="tabs-billing"
            aria-selected={isActive('/account-settings/billing')}>
            <span className="flex items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="h-4 w-4 mr-2"
                xmlns="http://www.w3.org/2000/svg">
                <mask
                  id="mask0_1076_92619"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="16">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.73341 8.58785L1.06675 5.25234C0.800081 5.11892 0.666748 4.91879 0.666748 4.65195C0.666748 4.38511 0.800081 4.18498 1.00008 4.05156L7.66675 0.716048C7.86675 0.649338 8.06675 0.649338 8.26675 0.716048L14.9334 4.05156C15.2001 4.18498 15.3334 4.38511 15.3334 4.65195C15.3334 4.91879 15.2001 5.11892 14.9334 5.25234L8.26675 8.58785C8.20008 8.65456 8.13341 8.65456 8.00008 8.65456C7.86675 8.65456 7.80008 8.65456 7.73341 8.58785ZM13.2001 4.65195L8.00008 2.05025L2.80008 4.65195L8.00008 7.25364L13.2001 4.65195ZM15.2667 11.0561C15.4001 11.3897 15.2667 11.7899 15.0001 11.9234L8.33341 15.2589C8.20008 15.3256 8.13341 15.3256 8.00008 15.3256C7.86675 15.3256 7.80008 15.3256 7.73341 15.2589L1.06675 11.9234C0.733415 11.7899 0.600081 11.3897 0.800081 11.0561C0.933415 10.7226 1.33341 10.5891 1.66675 10.7893L8.06675 13.9914L14.4667 10.7893C14.6667 10.5891 15.0667 10.7226 15.2667 11.0561ZM15.0001 8.58785C15.2667 8.45443 15.4001 8.05416 15.2667 7.72061C15.0667 7.38706 14.6667 7.25364 14.4667 7.45377L8.06675 10.6559L1.66675 7.45377C1.33341 7.25364 0.933415 7.38706 0.800081 7.72061C0.600081 8.05416 0.733415 8.45443 1.06675 8.58785L7.73341 11.9234C7.80008 11.9901 7.86675 11.9901 8.00008 11.9901C8.13341 11.9901 8.20008 11.9901 8.33341 11.9234L15.0001 8.58785Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_1076_92619)">
                  <rect width="16" height="15.9922" fill="currentcolor" />
                </g>
              </svg>
              <span>Billing</span>
              <i className="fas fa-chevron-down ml-3"></i>
            </span>
          </a>
        </li>
      </ul>
    </>
  );
};

export default SettingMenu;
